import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Card from '../Card';

export default () => (
  <>
    <Heading level={1}>Shadow Card</Heading>
    <Spacer size={16} />
    <Text>
      When the <Code>{'Card'}</Code> component has the <Code>{'shadow'}</Code>{' '}
      prop, the Card will render with a box shadow.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Card hasBorder={false} shadow />
        <Spacer size={20} />
        <Code>{'shadow={true}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
